export const tableRoleTitle = [
    { label: 'ລຳດັບ' },
    { label: 'ບົດບາດ' },
    { label: 'ເລເວລ' },
    { label: 'ຄຳອະທິບາຍ' },
    { label: 'ການຈັດການ' },
];